/** Regelversion 12: Karte „Neu in eurem Werkzeugkasten“. Hält die Zeit nicht an. */
import { useGame } from '../../store/game';
import { useTutorial } from './store';
import { useNextUnlock, UNLOCKS, unlockText } from './unlock';
import { useS } from '../../store/game';
import { track } from '../../lib/telemetry';

export function UnlockCard() {
  const u = useNextUnlock(); const { dispatch } = useGame(); const { markSeen, seen } = useTutorial();
  const S = useS();
  if (!u) return null;
  const T = unlockText(S, u);
  const ok = () => { markSeen('unlock-' + u.id); track('Tutorial.unlock', { id: u.id }); if (u.id === UNLOCKS[UNLOCKS.length - 1].id) markSeen('unlock-done'); };
  void seen;
  return (
    <div className="unlockcard" role="status">
      <span className="label">Neu in eurem Werkzeugkasten</span>
      <h3>{T.t}</h3>
      <p>{T.d}</p>
      <div className="actions">
        {u.tab && <button type="button" className="small yes" onClick={() => { dispatch('tab', u.tab!); ok(); }}>Ansehen</button>}
        <button type="button" className="small" onClick={ok}>Verstanden</button>
      </div>
    </div>
  );
}
